import { useState } from 'react';
import { useCookies } from 'react-cookie';

const cookieOptions = () => {
  const expiryDate = new Date();
  expiryDate.setMonth(expiryDate.getMonth() + 1);
  return { path: '/', expires: expiryDate };
};

/** Legacy linked both toggles to confirm_facebook until confirm_behavioral_marketing exists. */
const initialBehavioralMarketing = (cookies) => {
  if (cookies.confirm_behavioral_marketing !== undefined) {
    return !!Number(cookies.confirm_behavioral_marketing);
  }
  return !!Number(cookies.confirm_facebook);
};

/**
 * Cookie consent actions aligned with @kitconcept/volto-dsgvo-banner.
 */
export default function useCsjDsgvoConsent() {
  const [cookies, setCookie, removeCookie] = useCookies();
  const options = cookieOptions();

  const [confirmTracking, setConfirmTracking] = useState(
    !!Number(cookies.confirm_tracking),
  );
  const [confirmYoutube, setConfirmYoutube] = useState(
    !!Number(cookies.confirm_youtube),
  );
  const [confirmFacebook, setConfirmFacebook] = useState(
    !!Number(cookies.confirm_facebook),
  );
  const [confirmBehavioralMarketing, setConfirmBehavioralMarketing] =
    useState(() => initialBehavioralMarketing(cookies));
  const [confirmGoogle, setConfirmGoogle] = useState(
    !!Number(cookies.confirm_google),
  );
  const [confirmVimeo, setConfirmVimeo] = useState(
    !!Number(cookies.confirm_vimeo),
  );
  const [confirmTwitter, setConfirmTwitter] = useState(
    !!Number(cookies.confirm_twitter),
  );

  const persistModule = (name, enabled) => {
    if (enabled) {
      setCookie(name, 1, options);
    } else {
      removeCookie(name, options);
    }
  };

  const confirmSelection = () => {
    persistModule('confirm_tracking', confirmTracking);
    persistModule('confirm_facebook', confirmFacebook);
    persistModule(
      'confirm_behavioral_marketing',
      confirmBehavioralMarketing,
    );
    persistModule('confirm_youtube', confirmYoutube);
    persistModule('confirm_google', confirmGoogle);
    persistModule('confirm_vimeo', confirmVimeo);
    persistModule('confirm_twitter', confirmTwitter);
    setCookie('confirm_cookies', 1, options);
  };

  const confirmAll = () => {
    setCookie('confirm_tracking', 1, options);
    setCookie('confirm_facebook', 1, options);
    setCookie('confirm_behavioral_marketing', 1, options);
    setCookie('confirm_youtube', 1, options);
    setCookie('confirm_google', 1, options);
    setCookie('confirm_twitter', 1, options);
    setCookie('confirm_vimeo', 1, options);
    setCookie('confirm_cookies', 1, options);
  };

  const rejectAll = () => {
    setCookie('confirm_tracking', 0, options);
    setCookie('confirm_facebook', 0, options);
    setCookie('confirm_behavioral_marketing', 0, options);
    setCookie('confirm_youtube', 0, options);
    setCookie('confirm_google', 0, options);
    setCookie('confirm_twitter', 0, options);
    setCookie('confirm_vimeo', 0, options);
    setCookie('confirm_cookies', 1, options);
  };

  return {
    confirmTracking,
    setConfirmTracking,
    confirmYoutube,
    setConfirmYoutube,
    confirmFacebook,
    setConfirmFacebook,
    confirmBehavioralMarketing,
    setConfirmBehavioralMarketing,
    confirmGoogle,
    setConfirmGoogle,
    confirmVimeo,
    setConfirmVimeo,
    confirmTwitter,
    setConfirmTwitter,
    confirmSelection,
    confirmAll,
    rejectAll,
  };
}
